import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import DashboardLayout from '../../layouts/DashboardLayout'
import PageTitle from '../../components/PageTitle'
import { Helmet } from 'react-helmet'
import { toJS } from 'mobx'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import {
  Button,
  Col,
  DatePicker,
  Empty,
  Input,
  message,
  Pagination,
  Row,
  Select,
  Spin,
} from 'antd'
import TableComponent from '../../components/Common/TableComponent'
import { AvatarHasName } from '../../components/Common/Avatar'
import moment from 'moment'
import { TableBottomPaginationBlock } from '../../components/Common/Table'
import { PlusOutlined } from '@ant-design/icons'
import ReportCreateModal from './ReportCreateModal'

const { Option } = Select

const ReportPeriodicPage = props => {
  const {
    reportStore,
    loadingAnimationStore,
    userStore,
    riskStore,
    departmentStore,
    history,
    documentAccessibilityStore,
  } = props

  const {
    type,
    getReportListByQuarterly,
    reportListByQuarterly,
    totalReportListByQuarterly,
    pageIndex,
    pageSize,
  } = reportStore

  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const quarter = params.get('quarterly').split('-')[0]
  const currentYear = params.get('quarterly').split('-')[1]

  const [dateTime, setDateTime] = useState('')
  const [currentQuarterly, setCurrentQuarterly] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isDataComplete, setIsDataComplete] = useState(false)
  // Lấy danh sách người tạo
  const [allUsers, setAllUsers] = useState([])
  const [allUserr, setAllUserr] = useState([])
  //Lấy danh sách đơn vị
  const [unitData, setUnitData] = useState([])
  const [departData, setDepartData] = useState([])

  const [searchValue, setSearchValue] = useState('')
  const [resetFilter, setResetFilter] = useState(false)
  const [codeDepartment, setCodeDepartment] = useState('')
  const [changeDate, setChangeDate] = useState('')

  const [dataDoc, setDataDoc] = useState([])
  const [showAddReport, setShowAddReport] = useState(false)

  useEffect(() => {
    const fetchDocumentAccessibilities = async () => {
      try {
        loadingAnimationStore.showSpinner(true)
        const response = await documentAccessibilityStore.getDocumentAccessibilityByTypeAndAccess(
          'RISK_REPORT',
          'REPORT'
        )
        setDataDoc(response.data)
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    }

    fetchDocumentAccessibilities()
  }, [documentAccessibilityStore, loadingAnimationStore])

  const handleCancelAddReport = useCallback(() => {
    setShowAddReport(false)
  }, [])

  useEffect(() => {
    switch (quarter) {
      case 'q1':
        setDateTime(`${currentYear}-05-15`)
        setCurrentQuarterly(`Quý I/${currentYear}`)
        break
      case 'q2':
        setDateTime(`${currentYear}-08-15`)
        setCurrentQuarterly(`Quý II/${currentYear}`)
        break
      case 'q3':
        setDateTime(`${currentYear}-11-15`)
        setCurrentQuarterly(`Quý III/${currentYear}`)
        break
      case 'q4':
        setDateTime(`${Number(currentYear) + 1}-02-15`)
        setCurrentQuarterly(`Quý IV/${currentYear}`)
        break
      default:
        return
    }
  }, [params, quarter])

  // Giới hạn tìm kiếm ngày tạo
  const disabledDate = (current, currentYear) => {
    let start, end

    switch (quarter) {
      case 'q1':
        start = moment().year(currentYear).month(3).startOf('month')
        end = moment().year(currentYear).month(5).endOf('month')
        break
      case 'q2':
        start = moment().year(currentYear).month(6).startOf('month')
        end = moment().year(currentYear).month(8).endOf('month')
        break
      case 'q3':
        start = moment().year(currentYear).month(9).startOf('month')
        end = moment().year(currentYear).month(11).endOf('month')
        break
      case 'q4':
        start = moment()
          .year(currentYear)
          .add(1, 'years')
          .month(0)
          .startOf('month')
        end = moment().year(currentYear).add(1, 'years').month(2).endOf('month')
        break
      default:
        return false
    }

    return current && (current < start || current > end)
  }

  // Gọi api get list data
  useEffect(() => {
    if (dateTime) {
      getListData(searchValue, pageIndex)
    }
  }, [
    pageIndex,
    pageSize,
    dateTime,
    type,
    resetFilter,
    codeDepartment,
    changeDate,
  ])

  const getListData = async (searchValue, page) => {
    try {
      setIsLoading(true)
      const response = await getReportListByQuarterly({
        type: type,
        dateTime: dateTime,
        page: page ? page : pageIndex,
        size: pageSize,
        title: searchValue?.trim().replace(/\s+/g, ' '),
        code: codeDepartment,
        createdAt: changeDate,
      })
    } catch (error) {
      message.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  // Lấy danh sách người tạo
  useEffect(() => {
    loadingAnimationStore.showSpinner(true)
    setIsLoading(true)
    const fetchMentionUserList1 = userStore
      .getMentionUserList(true)
      .then(response => {
        return response.data.userDetails.map(user => ({
          id: user.userCode,
          fullName: user.fullName,
          username: user.user_name,
          image: user.image,
        }))
      })

    const fetchMentionUserList2 = userStore
      .getMentionUserList()
      .then(response => {
        return response.data.userDetails.map(user => ({
          id: user.userCode,
          fullName: user.fullName,
          username: user.user_name,
          image: user.image,
        }))
      })

    Promise.all([fetchMentionUserList1, fetchMentionUserList2])
      .then(([userList1, userList2]) => {
        setAllUsers(userList1)
        setAllUserr(userList2)
      })
      .finally(() => {
        loadingAnimationStore.showSpinner(false)
        setIsLoading(false)
      })

    return () => userStore.clearStore()
  }, [userStore, reportListByQuarterly])

  // Lấy danh sách đơn vị
  useEffect(() => {
    setIsLoading(true)
    riskStore
      .getRiskUnitsV3()
      .then(responseUnit => {
        setUnitData(responseUnit.data)
        return departmentStore.getAllDepartmentListV2()
      })
      .then(responseDepart => {
        setDepartData(responseDepart.data)
      })
      .catch(error => {
        message.error(error.vi || 'Đã có lỗi xảy ra!')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  const finalData2 = [...unitData, ...departData]
  const finalUserData = [...allUsers, ...allUserr]

  // Map danh sách người tạo với đơn vị vào danh sách hiện ra table
  useEffect(() => {
    const processReportLists = async () => {
      setIsLoading(true)

      const finalDataMap = finalData2.reduce((acc, item) => {
        acc[item.code] = item.name
        return acc
      }, {})

      const finalUserDataMap = finalUserData.reduce((acc, item) => {
        acc[item.username] = { image: item.image, fullName: item.fullName }
        return acc
      }, {})

      let allDataComplete = true

      const updatedReportLists = reportListByQuarterly.map(record => {
        record.name =
          finalDataMap[record.nddpv_code] ||
          finalDataMap[record.dvpt_code] ||
          finalDataMap[record.cqvp_code] ||
          record.name

        if (record.create_user in finalUserDataMap) {
          const userMatch = finalUserDataMap[record.create_user]
          record.image = userMatch.image
          record.fullName = userMatch.fullName
        } else {
          allDataComplete = false
        }

        if (!record.name || !record.image || !record.fullName) {
          allDataComplete = false
        }

        return record
      })

      setIsDataComplete(allDataComplete)
      setIsLoading(false)
    }

    processReportLists()
  }, [finalUserData, reportListByQuarterly])

  const handleChangePage = useCallback(
    p => {
      const pageIndex = p - 1
      reportStore.setFilter('pageIndex', pageIndex)
    },
    [reportStore]
  )

  // Tìm kiếm theo tiêu đề
  const handleInputChange = async e => {
    const { value } = e.target
    await setSearchValue(value)
    if (value === '') {
      setResetFilter(!resetFilter)
    }
  }
  const handleSearch = async () => {
    if (searchValue) {
      reportStore.setFilter('pageIndex', 0)
    }
    await getListData(searchValue, 0)
  }
  //

  // Tìm kiếm theo đơn vị
  const handleSelectChangeDepartment = value => {
    setCodeDepartment(value?.value)
  }
  //

  // Tìm kiếm theo ngày tạo
  const handleChangeDate = (date, dateString) => {
    if (date === null) {
      setChangeDate(null)
    } else {
      setChangeDate(moment(date).format('YYYY-MM-DD'))
    }
  }

  const tableColumns = [
    {
      title: 'Đơn vị',
      key: 'unit',
      render: record => <span>{record.name}</span>,
      width: '25%',
    },
    {
      title: 'Tiêu đề',
      key: 'title',
      render: record => <span>{record.title}</span>,
      width: '25%',
    },
    {
      title: 'Ngày tạo',
      width: '10%',
      align: 'center',
      render: record => {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
            }}>
            {moment(record?.created_at).format('DD/MM/YYYY')}
          </div>
        )
      },
    },
    {
      title: () => <div style={{}}>Người tạo</div>,
      width: '15%',
      render: record => (
        <div
          style={{
            display: 'flex',
            justifyContent: 'left',
            alignItems: 'center',
          }}>
          <AvatarHasName imgId={record?.image} name={record?.fullName} />
        </div>
      ),
    },
  ]

  const removeVietnameseTones = str => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Bỏ dấu
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D')
      .replace(/\s+/g, ' ') // Loại bỏ khoảng trắng
      .trim() // Loại bỏ khoảng trắng thừa
  }

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault() // Ngăn chặn sự kiện mặc định
      handleSearch()
    }
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>
          Báo cáo |{' '}
          {type === 'DINH_KY' ? 'Báo cáo định kỳ' : 'Báo cáo đột xuất'}
        </title>
      </Helmet>
      <PageTitle
        location={location}
        title={type === 'DINH_KY' ? 'Báo cáo định kỳ' : 'Báo cáo đột xuất'}
        quarter={currentQuarterly}
        hiddenGoBack>
        {dataDoc[0]?.status === true && (
          <Button
            onClick={() => {
              setShowAddReport(true)
            }}
            type={'primary'}
            icon={<PlusOutlined />}>
            Tạo mới
          </Button>
        )}
      </PageTitle>

      <ContentBlockWrapper style={{ minHeight: 600 }}>
        <Row gutter={[24, 24]}>
          <Col span={6}>
            <Input
              name="title"
              allowClear
              placeholder="Tìm kiếm theo tiêu đề"
              value={searchValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              // @ts-ignore
              onClear
              style={{ width: '100%' }}
            />
          </Col>
          <Col span={6}>
            <Select
              // @ts-ignore
              name="code"
              allowClear
              showSearch
              filterOption={(input, option) =>
                // @ts-ignore
                removeVietnameseTones(option.children.toLowerCase()).includes(
                  removeVietnameseTones(input.toLowerCase())
                )
              }
              placeholder="Tìm kiếm theo đơn vị"
              onChange={handleSelectChangeDepartment}
              style={{ width: '100%' }}
              labelInValue>
              {finalData2.map(item => (
                <Option key={item.code} value={item.code}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={6}>
            <DatePicker
              name="date"
              allowClear
              style={{ width: '100%' }}
              format={'DD/MM/YYYY'}
              onChange={handleChangeDate}
              disabledDate={current => disabledDate(current, currentYear)}
              placeholder="Tìm kiếm theo ngày tạo"
            />
          </Col>
        </Row>
        <TableComponent
          onRow={record => {
            return {
              onClick: () =>
                history.push(`/report/view/${record.code}?type=${type}`),
            }
          }}
          rowKey={record => record.code}
          dataSource={reportListByQuarterly}
          // @ts-ignore
          columns={tableColumns}
          pagination={false}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={'Không có dữ liệu'}
              />
            ),
          }}
          loading={isLoading}
        />
        <TableBottomPaginationBlock>
          <Pagination
            current={pageIndex + 1}
            pageSize={pageSize}
            total={totalReportListByQuarterly}
            showSizeChanger={false}
            onChange={handleChangePage}
          />
        </TableBottomPaginationBlock>
      </ContentBlockWrapper>
      {showAddReport && (
        <ReportCreateModal
          location={location}
          type={type}
          dateTime={dateTime}
          modalVisible={showAddReport}
          onCancel={handleCancelAddReport}
          isAdmin={true}
          typeCompany={type}
          loadAdminsList={''}
          // onRefresh={() => loadReportList(currentPage, pageSize)}
          // onClearFilters={handleClearAllFilters}
          editReport={null}
        />
      )}
    </DashboardLayout>
  )
}

export default inject(
  'reportStore',
  'loadingAnimationStore',
  'userStore',
  'riskStore',
  'departmentStore',
  'documentAccessibilityStore'
)(observer(ReportPeriodicPage))
